import React from 'react'
import { Box } from '@chatterbug/aaron'

export type Props = {
  name: string
  shouldBeUnderlined?: boolean
  url?: string
}

const UnitName: React.FC<Props> = ({
  name,
  url,
  shouldBeUnderlined = true,
}) => {
  return (
    <Box
      mt="0,5x"
      as="a"
      href={url}
      color="white100"
      variant="text.h4"
      sx={{
        ':hover, :visited, :active': { color: 'white100' },
        ...(shouldBeUnderlined && {
          textDecoration: 'underline',
          cursor: 'pointer',
        }),
      }}
    >
      {name}
    </Box>
  )
}

export default UnitName
